<form [formGroup]="scriptForm">
  <div class="row">
    <div class="col-3">
      <mbs-select [items]="osList"
                  [boldLabel]="false"
                  bindLabel="name"
                  bindValue="id"
                  [clearable]="false"
                  [searchable]="false"
                  appendTo="body"
                  formControlName="osType">
      </mbs-select>
    </div>
    <div class="col">
      <mbs-select [items]="scriptForm.get('osType').value === osTypes.Windows ? winScripts : linuxMacScripts"
                  [boldLabel]="false"
                  bindLabel="name"
                  bindValue="id"
                  [value]="scriptId"
                  [clearable]="true"
                  [searchable]="false"
                  appendTo="body"
                  formControlName="scriptId">
      </mbs-select>

    </div>
    <div class="col-1">
      <mbs-button [icon]="'fa fa-trash'"
                  (click)="scriptForm.get('enabled').setValue(false)">
      </mbs-button>
    </div>
  </div>

</form>
